import React from 'react'
import { Card, Badge, Button, Row, Col } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import { Dropdown } from 'react-bootstrap'
import {  Delete, Edit, MoreVert } from '@material-ui/icons';
import axios from 'axios';
import ENDPOINT from '../../context/EndPoint';
import SecurityHeaders from '../../context/SecurityHeaders';
import SnackbarToast from '../../components/toasts/SnackbarToast';
import UpdateMentor from './UpdateMentor';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

const MentorItem = ({reload,mentor}) => {
  const dispatch = useDispatch()
    const [open, setOpen] = React.useState({ open: false, message: '', type: '' });
 const [modelShow,setModelShow] = React.useState(false)
     const handleDelete = async (mentor_id) => {
      dispatch({type:'LOADING'})
        if (!mentor_id) {
          console.error("API Key ID is required for deletion.");
          return;
        }
        const data = new FormData();
        data.append("mentor_id", mentor_id);
        try {
     
    
          const response = await axios.post(ENDPOINT + "delete-mentor.php", data, SecurityHeaders);
          if (response) {
            if (response && response.data.status === "success" || true) {
           dispatch({type:'DONE_LOADING'})
              setOpen({ open: true, message: 'Delete successfully!', type: 'success' });          
              reload();
    
            } 
            else {              
              dispatch({ payload: response.data.message, type: 'ERROR' });
            }
          }
        } catch (error) {
          console.error("Error deleting", error);
          dispatch({ payload: error.message, type: 'ERROR' });
        }
      };
  return (
    <>
      

          <Col  lg={3} md={3} sm={12} className="mb-4">
          <SnackbarToast open={open} handleClose={() => setOpen({ open: false })} />
      <Modal show={modelShow} onHide={()=>setModelShow(false)}>
       
          <Modal.Body>
<UpdateMentor mentor={mentor} reload={reload} handleClose={()=>setModelShow(false)}/>
          </Modal.Body>
        
        </Modal>
                            <Card className="text-center shadow-sm position-relative card-container">
                              <div className="card-header-bg">
                         
        
        
        
                                <Dropdown className="options-dropdown position-absolute  ms-2" style={{ top: 10, right: 10 }} >
                                  <Dropdown.Toggle className="bg-white options p-0 w-fit h-fit  border-0" >
                                    <MoreVert className="text-dark" />
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                    <Dropdown.Item  >
                                     <Link to={'/update-mentor/'+mentor.mentor_id} > <Edit /> Update</Link>
                                    </Dropdown.Item>
                                    <Dropdown.Item className='text-danger' onClick={() => handleDelete(mentor.mentor_id)} >
                                      <Delete /> Delete
                                    </Dropdown.Item>
        
                                  </Dropdown.Menu>
                                </Dropdown>
        
        
        
        
                              </div>
                              <img src={mentor.profile_pic} className="profile-img" />
                              <Card.Body className="card-body-content mt-4">
                                <div className="d-flex justify-content-center align-items-center">
                                  <Card.Title>{mentor.first_name} {mentor.last_name}</Card.Title>
                                  <Badge bg="" className="ms-2 text-black">⭐ {mentor.ratings}</Badge>
                                </div>
                                <Card.Text className="text">{mentor.bio}</Card.Text>
                              </Card.Body>
                              <Card.Footer className="bg-white border-0">
                                <Button className="rounded-pill bg-white border border-2 text-black">
                                  View Profile
                                </Button>
                              </Card.Footer>
                            </Card>
                          </Col>
      
    </>
  )
}

export default MentorItem
